import React, { useEffect } from "react";
import MaintenancePage from "./MaintenancePage";
import { applySeo, seoConfig } from "./seo";

function App() {
  useEffect(() => {
    applySeo({
      title: seoConfig.title,
      description: seoConfig.description,
      path: "/",
    });
  }, []);

  return <MaintenancePage />;
}

export default App;
